import { customElement, property } from 'lit/decorators.js'
import { LitElement, html } from 'lit'
import { ifDefined } from 'lit/directives/if-defined.js'

@customElement('zaptic-report-subject')
export class ReportSubject extends LitElement {
    @property({
        attribute: 'unit-name',
    })
    unitName: string = ''

    @property({
        attribute: 'image-url',
    })
    imageUrl: string

    @property({ converter: (val) => val === 'true' })
    compact: boolean = true

    @property({
        converter: (val) => val ?? window.i18n('shared:reportSubject.title'),
    })
    label: string = window.i18n('shared:reportSubject.title')

    render() {
        return html`
            <zaptic-report-tile
                title-text=${this.label}
                detail-text=${this.unitName}
                image-url=${ifDefined(this.imageUrl)}
                ?compact=${this.compact}
            ></zaptic-report-tile>
        `
    }

    protected createRenderRoot() {
        return this
    }
}
